import React, { useState, useRef } from 'react';

function ModalTestPage() {
  const [showOneClickConfirmModal, setShowOneClickConfirmModal] = useState(false);
  const [oneClickUpgradeState, setOneClickUpgradeState] = useState({
    processing: false,
    error: null,
    success: false,
  });
  
  const upgradeInProgressRef = useRef(false);

  const mockPaymentMeta = {
    paymentMethodId: 'pm_test123',
    customerId: 'cus_test456',
    email: 'test@example.com',
    last4: '4242',
    name: 'Test User'
  };

  const simulateOneClickUpgrade = async () => {
    console.log('[ModalTestPage] 🚀 Starting one-click upgrade simulation');
    
    if (upgradeInProgressRef.current) {
      console.log('[ModalTestPage] ⚠️  Upgrade already in progress, skipping');
      return;
    }

    try {
      upgradeInProgressRef.current = true;

      // Ensure modal is open before starting
      if (!showOneClickConfirmModal) {
        console.log('[ModalTestPage] 📂 Opening modal before upgrade');
        setShowOneClickConfirmModal(true);
        // Give a brief moment for modal to open
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      setOneClickUpgradeState({
        processing: true,
        error: null,
        success: false,
      });

      console.log('[ModalTestPage] ⏳ Processing upgrade (simulated)...');

      // Simulate API call delay
      await new Promise(resolve => setTimeout(resolve, 2000));

      // Simulate success
      console.log('[ModalTestPage] ✅ Upgrade succeeded (simulated)');
      setOneClickUpgradeState({
        processing: false,
        error: null,
        success: true,
      });

      console.log('[ModalTestPage] 🎉 Modal should now show success state');
      // DON'T close modal here - let it show success

    } catch (error) {
      console.error('[ModalTestPage] ❌ Upgrade failed:', error);
      setOneClickUpgradeState({
        processing: false,
        error: error.message,
        success: false,
      });
    } finally {
      upgradeInProgressRef.current = false;
    }
  };

  const handleCloseModal = () => {
    console.log('[ModalTestPage] 🚪 Closing modal');
    setShowOneClickConfirmModal(false);
    setOneClickUpgradeState({
      processing: false,
      error: null,
      success: false,
    });
  };

  return (
    <div style={{ padding: '20px' }}>
      <h1>Modal Test Page</h1>
      <p>This page tests the one-click upgrade modal behavior</p>
      
      <button 
        onClick={() => setShowOneClickConfirmModal(true)}
        style={{ margin: '10px', padding: '10px' }}
      >
        Open Modal
      </button>
      
      <button 
        onClick={simulateOneClickUpgrade}
        style={{ margin: '10px', padding: '10px' }}
      >
        Simulate Auto-Upgrade
      </button>

      <div>
        <h3>Payment Meta (simulated):</h3>
        <pre>{JSON.stringify(mockPaymentMeta, null, 2)}</pre>
      </div>

      <div>
        <h3>Upgrade State:</h3>
        <pre>{JSON.stringify(oneClickUpgradeState, null, 2)}</pre>
      </div>

      <div>
        <h3>Modal Open:</h3>
        <p>{showOneClickConfirmModal ? 'Yes' : 'No'}</p>
      </div>

      {/* Modal */}
      {showOneClickConfirmModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            minWidth: '400px',
            textAlign: 'center'
          }}>
            {oneClickUpgradeState.processing && (
              <div>
                <h3>Processing Upgrade...</h3>
                <p>Please wait while we process your upgrade.</p>
              </div>
            )}

            {oneClickUpgradeState.error && (
              <div>
                <h3>Upgrade Failed</h3>
                <p>Error: {oneClickUpgradeState.error}</p>
                <button onClick={handleCloseModal}>Close</button>
              </div>
            )}

            {oneClickUpgradeState.success && (
              <div>
                <h3>🎉 Upgrade Successful!</h3>
                <p>Your account has been upgraded to Pro!</p>
                <button onClick={handleCloseModal}>Continue</button>
              </div>
            )}

            {!oneClickUpgradeState.processing && !oneClickUpgradeState.error && !oneClickUpgradeState.success && (
              <div>
                <h3>Upgrade to Pro</h3>
                <p>Payment Method: **** {mockPaymentMeta.last4}</p>
                <p>Email: {mockPaymentMeta.email}</p>
                <button 
                  onClick={simulateOneClickUpgrade}
                  style={{ margin: '10px', padding: '10px' }}
                >
                  Confirm Upgrade
                </button>
                <button 
                  onClick={handleCloseModal}
                  style={{ margin: '10px', padding: '10px' }}
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default ModalTestPage;
